// !!! Do not put any secrets in here, this is used by the client as well !!!
export const API_ROOT = '/api';
